import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { Currency } from './currency-format/currency-format.typings';
import {CurrencyApiService} from "../../services/currency.service";
import {ToasterService} from "angular2-toaster";
import {LoadService} from "../../services/load-service/load.service";
import {MatDialog} from '@angular/material/dialog';
import {CreateEditCurrencyComponent} from "./modals/create-edit-currency/create-edit-currency.component";
import {CountryInterface} from "../../interfaces/country.interface";


interface Response {
    total: number;
    result: Currency[];
}

@Component({
    selector: 'app-currency',
    templateUrl: './currency.component.html',
    styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent implements OnInit {

    currencies: Currency[] = [];
    isLoading: boolean = true;
    countries:CountryInterface[];

    constructor(
        private currencyService: CurrencyApiService,
        private ref: ChangeDetectorRef,
        private readonly _toasterService: ToasterService,
        private readonly _loadService: LoadService,
        public dialog: MatDialog,

    ) {
        this._toasterService = _toasterService;
    }

    ngOnInit(): void {
        this.getCurrencies();
        this.getCountries();
    }
    getCountries() {
        return this.countries = this.currencyService.getCountries()
    }
    getCurrencies() {
        this._loadService.enableLoad()
        this.currencyService.getCurrencies().subscribe(
            (response: Response) => {
                this.currencies = response.result
                this.isLoading = false;
                this._loadService.disableLoad()
                this.ref.detectChanges();
            }
        )
    }
    addCurrency(currency?: Currency) {
        this._loadService.enableLoad()
        this.currencyService.createCurrency(currency)
            .subscribe(
                data => {
                    this.getCurrencies();
                    this._loadService.disableLoad();
                }, error => {
                    this._loadService.disableLoad();
                    console.error("Error on create currency", error);
                    this._toasterService.pop(
                        'error',
                        'Error',
                        'Error to create a currency, Pleaes try again later. '
                    )
                }
            )
    }
    updateCurrency(currency?: Currency) {
        this.currencyService.updateCurrency(currency).subscribe(
            (response: Response) => {
                this.getCurrencies();
            }
            , error => {
                console.error('Error edit currency', error);
                this._toasterService.pop(
                    'error',
                    'Error',
                    'Error to edit a currency'
                );
            })
    }
    openDialogEditCreate(currencySelect?: Currency):void {
        const dialogRef = this.dialog.open(
            CreateEditCurrencyComponent,
            {
                data: {
                    currency: currencySelect,
                    countries: this.countries,
                },
            }
        );
        const resultModal$ = dialogRef.afterClosed();
        resultModal$
            .subscribe((recordcreated: Currency) => {
                if (recordcreated) {
                    if (currencySelect) {
                        const indiceRegistro = this.currencies.indexOf(currencySelect);
                        this.currencies[indiceRegistro] = recordcreated;
                        this.getCurrencies();
                        this._toasterService.pop(
                            'success',
                            'Success',
                            'currency created'
                        );
                    } else {
                        this.currencies.unshift(recordcreated);
                        this.getCurrencies();
                        this._toasterService.pop(
                            'success',
                            'Success',
                            'currency updated'
                        );
                    }
                }
            });
    }
    deleteCurrency(currency?: Currency) {
        this.currencyService.deleteCurrency(currency._id).subscribe(
            res => {
                this.getCurrencies();
                this._toasterService.pop(
                    'success',
                    'Success',
                    'currency deleled'
                );
            }
            ,error => {
                console.error('Error delete currency', error);
                this._toasterService.pop(
                    'error',
                    'Error',
                    'Error to delete a currency'
                );
            }
        )
    }



}
